import React from 'react'
import classNames from 'classnames'
import {EventImage} from '../../event-image'
import s from './mobile-image.scss'

export const MobileImage = () => <EventImage className={classNames(s.container)} />
